interface CameraPosition {
    x: number
    y: number
    z: number
}

interface ShadowCameraView {
    position: CameraPosition
    target: CameraPosition
}

/**
 * Camera inputs that can change a ground shadow's direction. Keeping this key
 * separate from FOV lets equivalent views reuse their baked texture.
 */
export const getCameraRelativeShadowViewKey = (
    camera:ShadowCameraView,
):string => JSON.stringify([
    camera.position.x,
    camera.position.y,
    camera.position.z,
    camera.target.x,
    camera.target.y,
    camera.target.z,
]);

/**
 * Rotate the established +X/+Z shadow-light rig into the requested camera's
 * horizontal frame. Reading the requested view avoids racing R3F while it
 * applies a new camera between consecutive renderbot previews.
 */
export const getCameraRelativeShadowLightRotationY = (
    camera:ShadowCameraView,
):number => Math.atan2(
    camera.position.x - camera.target.x,
    camera.position.z - camera.target.z,
);
